<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent scrollable max-width="800px">
      <template v-slot:activator="{ on }">
        <v-btn color="rtsPrimary" dark v-on="on">Edit</v-btn>
      </template>
      <v-card>
        <v-card-title fixed>
          <span class="headline">Edit Order #{{orderObj.client_reference}}</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-progress-linear
          v-if="loading"
          indeterminate
        ></v-progress-linear>
        <v-card-text style="height: 500px;">
          <v-container>
            <v-form ref="form">
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-text-field :disabled="loading" label="Client Ref#" v-model="orderObj.client_reference" required :rules="[v => !!v || 'Client Ref# is required']"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <AutoComplete :disabled="loading" :default="order.client" :required="required" :rules="[v => !!v || 'Customer is required']" label="Customer*" itemText="name" url="clients/?slug__contains=" field="client" type="foriegn" @clicked="getAutoCompleteData" />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <AutoComplete :disabled="loading" :default="order.product" :required="required" :rules="[v => !!v || 'Product is required']" label="Product*" itemText="name" url="products/?slug__contains=" field="product" type="foriegn" @clicked="getAutoCompleteData" @valueCleared="productCleared"/>
              </v-col>
              <v-col cols="12" sm="6" md="8">
                <v-text-field :disabled="loading" label="Property Address" v-model="orderObj.addressLine" required :rules="[v => !!v || 'Property Address is required']" ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field :disabled="loading" label="Zip Code*" v-model="orderObj.zip_code" required :rules="[v => !!v || 'Zip code is required']"></v-text-field>
              </v-col>
              <!--
              <v-col cols="12" sm="6" md="4">
                  <AutoComplete :default="order.address.city" label="City" itemText="name" url="cities/?slug__contains=" field="city" type="foriegn" @clicked="getAutoCompleteData" />
              </v-col>
              -->
              <v-col cols="12" sm="6" md="6">
                  <AutoComplete :disabled="loading" :default="order.address.state" :required="required" :rules="[v => !!v || 'State is required']" label="State*" itemText="name" url="states/?slug__contains=" field="state" type="foriegn" @clicked="getAutoCompleteData" />
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <AutoComplete :disabled="loading" :default="order.address.county" :required="required" :rules="[v => !!v || 'County is required']" label="County*" itemText="name" :url="countyURL" field="county" type="foriegn" @clicked="getAutoCompleteData" />
              </v-col>
              <v-col cols="12">
                <v-text-field :disabled="loading" label="Loan#" v-model="orderObj.loan"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field :disabled="loading" label="Price" v-model="orderObj.price"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field :disabled="loading" label="Subject Lien Amount" v-model="orderObj.subject_lien_amount"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="8">
                <v-text-field :disabled="loading" label="First Borrower" v-model="orderObj.first_borrower"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-text-field :disabled="loading" label="Last 4 of ssn" v-model="orderObj.last_4_of_ssn"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="8">
                <v-text-field :disabled="loading" label="Second Borrower" v-model="orderObj.second_borrower"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-text-field :disabled="loading" label="Last 4 of ssn 2" v-model="orderObj.last_4_of_ssn_2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <DatePicker :disabled="loading" :pickerData="EffectiveDatePickerData" @clicked="getDateFromDatePicker"/>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <DatePicker :disabled="loading" :pickerData="PriorEffectiveDatePickerData" @clicked="getDateFromDatePicker"/>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <DatePicker :disabled="loading" :pickerData="SubjectLienPickerData" @clicked="getDateFromDatePicker"/>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <DatePicker :disabled="loading" :pickerData="PrepareDatePickerData" @clicked="getDateFromDatePicker"/>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <DatePicker :disabled="loading" :pickerData="SearchPdStDtPickerData" @clicked="getDateFromDatePicker"/>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <DateTimePicker :disabled="loading" :pickerData="OrderDuePickerData" @clicked="getDateFromDatePicker"/>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-switch :disabled="loading" v-model="orderObj.on_hold" class="mx-2" label="On Hold"></v-switch>
              </v-col>
              <v-col cols="12" sm="6" md="6" v-if="!shouldShowCustomUi" >
                <v-switch :disabled="loading" v-model="orderObj.is_developer_deed" class="mx-2" label="Is Developer Deed"></v-switch>
              </v-col>
              <v-col cols="12" :sm="shouldShowCustomUi?'12':'6'" :md="shouldShowCustomUi?'12':'6'">
                <v-switch v-if="!shouldShowCustomUi" :disabled="loading" v-model="orderObj.is_effective_date_changed" class="mx-2" label="Only Effective Date Changed"></v-switch>
                <div v-else>
                    <v-radio-group v-model="orderObj.is_effective_date_changed" label="Only Effective Date Changed" class="radio-group-container" row>
                      <v-radio label="Only Effective Date Change" :value="true"></v-radio>
                      <v-radio label="New Recording Founds" :value="false"></v-radio>
                    </v-radio-group>
                  </div>
              </v-col>
              <v-col cols="12" :sm="shouldShowCustomUi?'12':'6'" :md="shouldShowCustomUi?'12':'6'">
                <v-switch v-if="!shouldShowCustomUi" :disabled="loading" v-model="orderObj.borrower_name_in_title" class="mx-2" label="Borrower Name In Title"></v-switch>
                <div v-else>
                    <v-radio-group v-model="orderObj.borrower_name_in_title" label="Borrower Name In Title" class="radio-group-container" row>
                      <v-radio label="Yes" :value="true"></v-radio>
                      <v-radio label="No" :value="false"></v-radio>
                    </v-radio-group>
                  </div>
              </v-col>
              <v-col cols="12" sm="6" md="6" v-if="order.product.slug == 'update'">
                <v-switch :disabled="loading" v-model="orderObj.new_pps_recordings_found" class="mx-2" label="New Recording Found"></v-switch>
              </v-col>
              <v-col cols="12" sm="6" md="6" v-if="order.product.slug == 'prior-policy-search'">
                <v-combobox
                    v-model="orderObj.note_type"
                    :items="note_type_categories"
                    item-text="name"
                    label="Select Note Type"
                    chips
                >
                <template v-slot:selection="data">
                    <v-chip
                        :key="JSON.stringify(data.item)"
                        v-bind="data.attrs"
                        :input-value="data.selected"
                        :disabled="data.disabled"
                    >
                    <v-avatar
                        class="accent white--text"
                        left
                        v-text="data.item.slice(0, 1).toUpperCase()"
                    ></v-avatar>
                        {{ data.item }}
                    </v-chip>
                </template>
                </v-combobox>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  :disabled="loading"
                  filled
                  v-model="orderObj.note"
                  label="Order Note"
                  rows="4"
                  row-height="30"
                  shaped
                ></v-textarea>
              </v-col>
              <v-col cols="12">
                <AutoComplete :disabled="loading" :default="order.status" label="Stage*" :required="required" :rules="[v => !!v || 'Stage is required']" itemText="name" url="order_statuses/?slug__contains=" field="status" type="foriegn" @clicked="getAutoCompleteData" />
              </v-col>
              <v-col cols="12">
                <v-text-field :disabled="loading" label="TS Identifier#" v-model="orderObj.ts_identifier"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <!--<v-text-field :disabled="loading" label="ETA Status" v-model="orderETA.status" ></v-text-field>-->
                <DateTimePicker :disabled="loading" :pickerData="OrderETAPickerData" @clicked="getDateFromDatePicker"/>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field :disabled="loading" label="ETA Notes" v-model="orderETA.notes" ></v-text-field>
              </v-col>
            </v-row>
            </v-form>
          </v-container>
          <small>*indicates required field</small>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions fixed>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false" :disabled="loading">Close</v-btn>
          <v-btn color="blue darken-1" text @click="updateOrder()" :disabled="loading" :loading="loading">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import DatePicker from '@/components/datePicker.vue'
import DateTimePicker from '@/components/dateTimePicker.vue'
import AutoComplete from '@/components/autoComplete.vue'
import { UPDATEORDER, POSTNOTE, GETORDERBYYID, GETCLIENTPRODUCTFEES, ADDORDERETA } from '@/store/actions.type'
import { PRODUCT_NAMES } from '@/constants'

export default {
  name: 'EditOrder',
  components: {
    DatePicker,
    DateTimePicker,
    AutoComplete
  },
  data: () => ({
    loading: false,
    dialog: false,
    countyURL: null,
    statusText: null,
    EffectiveDatePickerData: { date: null, name: 'Effective Date', field: 'effective_date' },
    PriorEffectiveDatePickerData: { date: null, name: 'Prior Effective Date', field: 'prior_effective_date' },
    SubjectLienPickerData: { date: null, name: 'SubjectLien Date', field: 'subject_lien_date' },
    PrepareDatePickerData: { date: null, name: 'Prepare Date', field: 'prepared_date' },
    SearchPdStDtPickerData: { date: null, name: 'Search Pd St Date', field: 'search_pd_st_date' },
    OrderDuePickerData: { date: null, name: 'Due Date', field: 'due_on' },
    OrderETAPickerData: { date: null, name: 'ETA Date', field: 'eta_date' },
    orderObj: null,
    //  note_type_categories: [{ name: 'No New Docs' }, { name: 'Expected Docs' }, { name: 'New Docs' }]
    note_type_categories: [ 'No New Docs', 'Expected Docs', 'New Docs' ],
    orderETA: { eta_date: null, notes: null },
    customUiProductNames: PRODUCT_NAMES,
    shouldShowCustomUi: false
  }),
  props: {
    order: null
  },
  mounted () {},
  methods: {
    getDateFromDatePicker (value) {
      console.log(value) // someValue
      if (value.field === 'due_on') {
        this.orderObj[value.field] = value.date
      } else if (value.field === 'eta_date') {
        this.orderETA[value.field] = value.date
      } else {
        this.orderObj[value.field] = value.date + ' 00:00:00'
      }
    },
    updateOrder (data) {
      console.log(this.orderObj)
      console.log(this.orderETA)
      this.loading = true
      if (this.$refs.form.validate()) {
        if (this.orderETA.eta_date != null && this.orderETA.notes != null) {
          let payload = {
            order: this.order.id,
            eta_date: this.orderETA.eta_date,
            eta_notes: this.orderETA.notes
          }
          this.$store.dispatch(ADDORDERETA, payload)
            .then(response => {
              response.created_by = JSON.parse(window.localStorage.getItem('auth')).user_data
              this.$emit('order_eta_add', response)
            })
            .catch(response => {
              this.loading = false
            })
        }
        this.$store.dispatch(UPDATEORDER, this.orderObj)
          .then(response => {
            console.log(response)
            let payload = {
              id: this.order.id
            }
            this.$store
              .dispatch(GETORDERBYYID, payload)
              .then(response => {
                this.order = response
                this.activeTab = this.order.status
                this.loading = false
                // console.log(this.order)
                this.loading = false
                this.order = response
                this.$emit('newOrderAdded', response)
                this.$emit('updateOrder', response)
                this.$emit('order_edit', response)
                // this.uporderinfo()
                // console.log(this.order.address)
                this.dialog = false
                let slug = ''
                try {
                  slug = this.order.status.slug
                } catch (e) {
                  slug = ''
                }
                if (slug !== '') { // find the current tab based on slug
                  let elems = document.querySelector("[data-attr='" + slug + "']")
                  if (elems) {
                    if (!elems.classList.contains('activeStatusTab')) {
                      if (elems.disabled) {
                        this.$router.push(`/`)
                      } else {
                        setTimeout(() => {
                          elems.click()
                        }, 600)
                      }
                    }
                  }
                }
              })
            if (this.statusText) {
              console.log('Adding notes')
              let noteCreatedBy = JSON.parse(window.localStorage.getItem('auth')).user_data
              let assignerNotePayload = {
                note: `Order moved to ${this.statusText} Stage by ${noteCreatedBy.username}`,
                order: this.order.id,
                type: 'Order'
              }
              this.$store.dispatch(POSTNOTE, assignerNotePayload).then(noteResponse => {
                console.log(noteResponse)
              })
            }
          })
          .catch(response => {
            this.loading = false
          })
      } else {
        console.log('error')
        setTimeout(() => {
          let errorFirst = document.querySelector('.error--text')
          if (errorFirst) {
            const errorFirstInput = errorFirst.querySelector('input, select')
            errorFirst.scrollIntoView({ behavior: 'instant' })
            errorFirstInput.focus()
          }
        }, 400)
        this.loading = false
      }
    },
    getAutoCompleteData (data) {
      if (data.__field === 'product') {
        this.shouldShowCustomUi = false
        if (this.customUiProductNames.includes(data.name)) {
          this.shouldShowCustomUi = true
        }
      }
      if (data.__field === 'status') {
        this.statusText = data.name
      }
      if (data.__type === 'foriegn') {
        this.orderObj[data.__field] = data.id
        if (data.__field === 'state') {
          this.countyURL = `counties/?state__id=${data.id}`
          // this.orderObj['county'] = null
          if (this.order.address.state.id !== data.id) {
            this.order.address.county = null
          }
        }
      } else {
        this.orderObj[data.__field] = data
      }
      this.order[data.__field] = data
      if (['product', 'county', 'state', 'client'].includes(data.__field)) {
        this.getProductFees()
      }
    },
    getProductFees () {
      if (this.orderObj.client !== undefined && this.orderObj.product !== undefined && this.orderObj.state !== undefined && this.orderObj.county !== undefined) {
        let payload = {
          client__id: this.orderObj.client,
          product__id: this.orderObj.product,
          state__id: this.orderObj.state,
          county__id: this.orderObj.county
        }
        this.$store.dispatch(GETCLIENTPRODUCTFEES, payload)
          .then(response => {
            if (response.count > 0) {
              this.orderObj.price = response.results[0].prices.toFixed(2)
              this.loading = false
            } else {
              this.orderObj.price = ''
            }
          })
          .catch(response => {
            this.loading = false
          })
      }
    },
    productCleared () {
      this.shouldShowCustomUi = false
    }
  },
  watch: {
    order: {
      immediate: true,
      handler (newVal, oldVal) {
        // this.loading = false
        this.orderObj = {
          id: this.order.id,
          client_reference: this.order.client_reference,
          first_borrower: this.order.first_borrower,
          last_4_of_ssn: this.order.last_4_of_ssn,
          second_borrower: this.order.second_borrower,
          last_4_of_ssn_2: this.order.last_4_of_ssn_2,
          price: this.order.price,
          subject_lien_amount: this.order.subject_lien_amount,
          effective_date: this.order.effective_date,
          prior_effective_date: this.order.prior_effective_date,
          subject_lien_date: this.order.subject_lien_date,
          prepared_date: this.order.prepared_date,
          search_pd_st_date: this.order.search_pd_st_date,
          due_on: this.order.due_on,
          loan: this.order.loan,
          note: this.order.note,
          on_hold: this.order.on_hold,
          is_developer_deed: this.order.is_developer_deed,
          new_pps_recordings_found: this.order.new_pps_recordings_found,
          is_effective_date_changed: this.order.is_effective_date_changed,
          borrower_name_in_title: this.order.borrower_name_in_title,
          status: this.order.status.id,
          client: this.order.client.id,
          product: this.order.product.id,
          addressLine: this.order.address.street,
          zip_code: this.order.address.zip_code,
          ts_identifier: this.order.ts_identifier,
          note_type: this.order.note_type
        }
        this.EffectiveDatePickerData.date = this.orderObj.effective_date
        this.PriorEffectiveDatePickerData.date = this.orderObj.prior_effective_date
        this.SubjectLienPickerData.date = this.orderObj.subject_lien_date
        this.PrepareDatePickerData.date = this.orderObj.prepared_date
        this.SearchPdStDtPickerData.date = this.orderObj.search_pd_st_date
        this.OrderDuePickerData.date = this.orderObj.due_on
        this.countyURL = `counties/?state__id=${this.order.address.state.id}`
      }
    }
  }
}
</script>
<style scoped>
.radio-group-container,::v-deep .v-input--selection-controls{
  margin-top:0px;
  margin-bottom:0px !important;
}
::v-deep .v-input__slot{
  margin-bottom:0px !important;
}
::v-deep .v-input--radio-group__input>.v-label{
margin-right:40px;
}
</style>
